import React, { useEffect, useMemo, useState } from 'react'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomModal,
  InputText,
  SectionTitle,
} from '../../../../components'
import AtivoPatrimonialHttp from '../../../../services/api/https/patrimonio/ativo-patrimonial.http'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { getTps } from '../../../../services/localstorage/localstorage.service'
import { tableCellCentered } from '../../../../assets/js/styles'

const NEW_ATIVO_PATRIMONIAL = {
  id: null,
  num_ativo: '',
  name: '',
  tps: [],
}

function AtivoPatrimonialModal({
  visible = false,
  ativoPatrimonial = null,
  onResponse,
  selectedOwner,
}) {
  const tps = useMemo(() => {
    return getTps(false).map(tp => ({ selected: false, ...tp }))
  }, [])

  // Hooks
  const [ativo, setAtivo] = useState({ ...NEW_ATIVO_PATRIMONIAL })
  const [ownerId, setOwnerId] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [selecionarTodos, setSelecionarTodos] = useState(false)
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    if (visible) {
      setOwnerId(selectedOwner.patrimonio_owner_id)
      if (ativoPatrimonial) {
        const mergedTps = tps.map(tp => {
          const selectedTp = ativoPatrimonial.tps.find(t => t.id === tp.id)
          tp.selected = !!selectedTp
          return tp
        })
        setAtivo({ ...ativoPatrimonial, tps: mergedTps })
      } else {
        setAtivo({ ...NEW_ATIVO_PATRIMONIAL, tps })
      }
    }
  }, [visible])

  useEffect(() => {
    setAtivo(prevState => {
      prevState.tps.forEach(tp => {
        tp.selected = selecionarTodos
      })
      return { ...prevState }
    })
  }, [selecionarTodos])

  // Events
  const onBtnSalvarClicked = () => {
    setIsLoading(true)
    AtivoPatrimonialHttp.saveAtivo({
      id: ativo.id,
      num_ativo: ativo.num_ativo,
      name: ativo.name,
      tps_ids: ativo.tps.filter(tp => tp.selected).map(tp => tp.id),
      patrimonio_owner_id: ownerId,
    })
      .then(savedAtivo => {
        setIsLoading(false)
        onResponse('success', savedAtivo)
      })
      .catch(e => {
        setIsLoading(false)
        onResponse('error', e)
      })
  }
  const onCheckboxChange = tp => {
    setAtivo(prevState => {
      const index = prevState.tps.findIndex(t => t.id === tp.id)
      if (index !== -1) {
        prevState.tps[index].selected = !prevState.tps[index].selected
      }
      return { ...prevState }
    })
  }

  // Render
  return (
    <CustomModal
      width={600}
      header="Ativo Patrimonial"
      isVisible={visible}
      onClose={() => onResponse('close')}
    >
      <div className="p-grid">
        <div className="p-col-4">
          <InputText
            label="Número Patrimônio :"
            value={ativo.num_ativo}
            onChange={value => setAtivo({ ...ativo, num_ativo: value })}
          />
        </div>
        <div className="p-col-8">
          <InputText
            label="Ativo Patrimonial :"
            value={ativo.name}
            onChange={value => setAtivo({ ...ativo, name: value })}
          />
        </div>
        <div className="p-col-12">
          <SectionTitle title={'Operações que terão acesso ao Ativo:'} />
        </div>
        <div className="p-col-12">
          <CustomCheckbox
            checked={selecionarTodos}
            onChange={() => setSelecionarTodos(!selecionarTodos)}
          >
            Selecionar Todos
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <DataTable
            value={ativo.tps}
            paginator={true}
            rows={3}
            header={<CustomDataTableHeader onChange={setGlobalFilter} />}
            globalFilter={globalFilter}
          >
            <Column
              header={'#'}
              body={tp => (
                <CustomCheckbox checked={tp.selected} onChange={() => onCheckboxChange(tp)} />
              )}
              style={tableCellCentered(80)}
            />
            <Column field={'name'} header={'Operação Logística'} />
          </DataTable>
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onBtnSalvarClicked}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}

export default AtivoPatrimonialModal
